import React from "react";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import { compose } from "redux";
import SmartRender from "containers/SmartRender";
import styles from "./styles";
import { createStructuredSelector } from "reselect";
import { submitCancelNumberChange } from "ducks/actions";
import {
  makeSelectFormattedOldNumber,
  makeSelectFormattedNewNumber,
  makeSelectFormattedChangeNumberDate,
  makeSelectCanCancelNumberChange,
  makeSelectGuestOrder
} from "ducks/selectors";
import { forms, paths } from "utils/constants";
import { gotoUrl } from "utils/helpers";
import get from "lodash/get";
import validate from "validations";
import isEmpty from "lodash/isEmpty";
import isFunction from "lodash/isFunction";

const SubmittedNumberChange = Component =>
  function Comp(props) {
    return <Component {...props} />;
  };

const mapStateToProps = createStructuredSelector({
  formattedOldNumber: makeSelectFormattedOldNumber(),
  formattedNewNumber: makeSelectFormattedNewNumber(),
  formattedChangeNumberDate: makeSelectFormattedChangeNumberDate(),
  canCancelNumberChange: makeSelectCanCancelNumberChange(),
  guestOrder: makeSelectGuestOrder(),
  styles: () => styles
});

export function mapDispatchToProps(dispatch) {
  return {
    submitCancelChangeNumber: (params, callback) => {
      dispatch(submitCancelNumberChange(params, callback));
    }
  };
}

export const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  submitCancelChangeNumberAndNavigate: (navigate, payload) => {
    const params = {
      orderId: get(stateProps, "guestOrder.id"),
      order_ref: get(stateProps, "guestOrder.orderRef")
    };

    dispatchProps.submitCancelChangeNumber(params, (_, error) => {
      if (isEmpty(error)) {
        if (get(_, "code") !== -1) isFunction(navigate) && navigate();
        else {
          gotoUrl(paths.CHANGE_NUMBER_CANCEL_FAIL);
        }
      }
    });
  },
  messageData: {
    oldNumber: get(stateProps, "formattedOldNumber.formattedNumber"),
    newNumber: get(stateProps, "formattedNewNumber.formattedNumber"),
    formattedChangeNumberDate: get(stateProps, "formattedChangeNumberDate")
  }
});

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export default compose(
  withConnect,
  reduxForm({
    form: forms.CHANGE_NUMBER_FORM,
    validate: validate,
    destroyOnUnmount: false
  })
)(SubmittedNumberChange(SmartRender));
